import { CompanyForm } from '@/components/forms/company-form'
import { useAuth } from '@/contexts/AuthContext'
import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { createClient } from '@/lib/supabase/client'

export default function CriarEmpresaPage() {
  const { user, loading } = useAuth()
  const navigate = useNavigate()
  const [checking, setChecking] = useState(true)
  const [hasCompany, setHasCompany] = useState(false)
  const supabase = createClient()

  useEffect(() => {
    let isMounted = true
    const checkCompany = async () => {
      if (!loading && user) {
        const { data } = await supabase
          .from('users')
          .select('current_company_id')
          .eq('id', user.id)
          .single()
        if (isMounted) {
          if (data?.current_company_id) {
            setHasCompany(true)
          } else {
            setHasCompany(false)
          }
          setChecking(false)
        }
      } else if (!loading && !user) {
        navigate('/auth/login')
      }
    }
    checkCompany()
    return () => { isMounted = false }
  }, [user, loading, navigate, supabase])

  if (loading || checking) {
    return <div>Carregando...</div>
  }

  return (
    <div className="container relative min-h-screen flex-col items-center justify-center grid lg:max-w-none lg:grid-cols-2 lg:px-0">
      <div className="relative hidden h-full flex-col bg-muted p-10 text-white lg:flex dark:border-r">
        <div className="absolute inset-0 bg-zinc-900" />
        <div className="relative z-20 flex items-center text-lg font-medium">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="mr-2 h-6 w-6"
          >
            <path d="M15 6v12a3 3 0 1 0 3-3H6a3 3 0 1 0 3 3V6a3 3 0 1 0-3 3h12a3 3 0 1 0-3-3" />
          </svg>
          Orçamento Solis
        </div>
        <div className="relative z-20 mt-auto">
          <blockquote className="space-y-2">
            <p className="text-lg">
              Gerencie seus clientes, serviços e equipe em um só lugar.
            </p>
          </blockquote>
        </div>
      </div>
      <div className="lg:p-8">
        <div className="mx-auto flex w-full flex-col justify-center space-y-6 sm:w-[350px]">
          <div className="flex flex-col space-y-2 text-center">
            <h1 className="text-2xl font-semibold tracking-tight">
              Criar sua empresa
            </h1>
            <p className="text-sm text-muted-foreground">
              Preencha os dados da sua empresa para começar
            </p>
          </div>
          <CompanyForm />
        </div>
      </div>
    </div>
  )
} 